import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./bo/context/AuthContext";
import { CartProvider } from "./bo/context/CartContext";
import { Layout, RequireAuth } from "./bo/components/Layout";
import Home from "./bo/pages/Home";
import Catalog from "./bo/pages/Catalog";
import ProductPage from "./bo/pages/ProductPage";
import Stores from "./bo/pages/Stores";
import Checkout, { CartPage } from "./bo/pages/Checkout";
import { Orders, OrderDetail } from "./bo/pages/Orders";
import { Favorites, Profile, StoreApply, CourierApply } from "./bo/pages/Account";
import { Login, Register, VerifyEmail, ForgotPassword, ResetPassword, ActivateAccount } from "./bo/pages/AuthPages";
import CourierPanel from "./bo/pages/CourierPanel";
import RideDemo from "./bo/pages/RideDemo";
import DriverDemo from "./bo/pages/DriverDemo";
import { Obogo, Transportes, Passes, Help } from "./bo/pages/Info";
import Recargas from "./bo/pages/Recargas";
import StorePanel from "./bo/pages/StorePanel";
import AdminPanel from "./bo/pages/admin/AdminPanel";
import StepUpDialog from "./bo/components/StepUpDialog";
import { SiteProvider, PreviewBar } from "./bo/context/SiteContext";
import CmsPage from "./bo/pages/CmsPage";
import Complaints from "./bo/pages/Complaints";

const STAFF_ROLES = ["admin", "ops_admin", "store_manager", "obogo_manager", "finance_manager", "support"];
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const auth = (el, roles) => <RequireAuth roles={roles}>{el}</RequireAuth>;

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <SiteProvider>
        <CartProvider>
          <PreviewBar />
          <Toaster position="top-center" richColors />
          <StepUpDialog />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalog />} />
              <Route path="/ofertas" element={<Catalog deals />} />
              <Route path="/produto/:id" element={<ProductPage />} />
              <Route path="/lojas" element={<Stores />} />
              <Route path="/obogo" element={<Obogo />} />
              <Route path="/recargas" element={<Recargas />} />
              <Route path="/ajuda" element={<Help />} />
              <Route path="/p/:slug" element={<CmsPage />} />
              <Route path="/conta/reclamacoes" element={auth(<Complaints />)} />
              <Route path="/favoritos" element={auth(<Favorites />)} />
              <Route path="/conta/transportes" element={<Transportes />} />
              <Route path="/conta/passes" element={<Passes />} />
            </Route>
            <Route element={<Layout rail={false} />}>
              <Route path="/carrinho" element={<CartPage />} />
              <Route path="/checkout" element={auth(<Checkout />)} />
              <Route path="/conta/pedidos" element={auth(<Orders />)} />
              <Route path="/conta/pedidos/:id" element={auth(<OrderDetail />)} />
              <Route path="/conta/perfil" element={auth(<Profile />)} />
              <Route path="/vender" element={<StoreApply />} />
              <Route path="/painel-loja" element={auth(<StorePanel />, ["store"])} />
              <Route path="/admin" element={auth(<AdminPanel />, STAFF_ROLES)} />
              <Route path="/estafeta" element={auth(<CourierPanel />, ["courier"])} />
              <Route path="/estafeta/candidatura" element={<CourierApply />} />
              <Route path="/mobilidade" element={<RideDemo />} />
              <Route path="/motorista-demo" element={auth(<DriverDemo />)} />
              <Route path="/ativar-conta" element={<ActivateAccount />} />
              <Route path="/entrar" element={<Login />} />
              <Route path="/registar" element={<Register />} />
              <Route path="/verificar-email" element={<VerifyEmail />} />
              <Route path="/recuperar-palavra-passe" element={<ForgotPassword />} />
              <Route path="/redefinir-palavra-passe" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </CartProvider>
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
